import { ScheduledAdminLoading } from '@/views/community/channel/scheduled/admin/scheduled-admin.loading';

export default ScheduledAdminLoading;
